export default {
  artist: {
    routes: [
      {
        component: 'DashboardContainer',
        url: '/dashboard/:token?',
      },
      {
        component: 'QuestionnaireContainer',
        url: '/questionnaire',
      },
      {
        component: 'DashboardContainer',
        url: '/dashboard/:artistId?/:offerId',
      },
    ],
  },
  manager: {
    routes: [
      {
        component: 'DashboardContainer',
        url: '/dashboard/:token?',
      },
      {
        component: 'DashboardContainer',
        url: '/dashboard/:artistId?/:offerId',
      },
      {
        component: 'QuestionnaireContainer',
        url: '/questionnaire',
      },

    ],
  },
  systemAdmin: {
    routes: [
      {
        component: 'OfferListingContainer',
        url: '/admin/offer',
      },
      {
        component: 'AdminListContainer',
        url: '/admin/artist',
      },
      {
        component: 'AdminListContainer',
        url: '/admin/manager',
      },
      {
        component: 'CreateOfferContainer',
        url: '/admin/offer/create',
      },
      {
        component: 'CreateUserContainer',
        url: '/admin/artist/import',
      },
      {
        component: 'CreateUserContainer',
        url: '/admin/manager/import',
      },
      {
        component: 'CreateOfferContainer',
        url: '/admin/offer/edit/:offerId',
      },
      {
        component: 'OfferDetailContainer',
        url: '/admin/offer/detail/:offerId',
      },
      {
        component: 'AnalyticsContainer',
        url: '/admin/analytics',
      },
    ],
  },
  common: {
    routes: [
      {
        component: 'CreatePasswordContainer',
        url: '/createPassword',
      },
    ],
  },
};
